import { type ComponentProps } from 'react';
import cx from 'classnames';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import styles from '@redturtle/qubicaamf-theme/components/Blocks/commons/CTA.module.css';
import CtaIcon from '@redturtle/qubicaamf-theme/components/Icons/CtaIcon';

interface CTAProps {
  ctaButtonStyle: 'button' | 'simple' | 'big_button';
  linkIcon?: string;
  cta_color?: 'white' | 'black';
  product_id?: string;
}

const CTA = (props: ComponentProps<typeof UniversalLink> & CTAProps) => {
  const {
    ctaButtonStyle,
    linkIcon,
    cta_color,
    children,
    href,
    product_id,
    ...rest
  } = props;

  const params = new URLSearchParams({
    product_id: props.product_id,
  }).toString();

  const url = !!props.product_id ? `${props.href}?${params}` : props.href;
  return (
    <div
      className={cx('blocks-cta', {
        [styles.padding]: ctaButtonStyle === 'big_button',
      })}
    >
      <UniversalLink
        className={cx([styles.cta_link], {
          [styles.cta_button_style]: ctaButtonStyle === 'button',
          [styles.cta_simple_style]: ctaButtonStyle === 'simple',
          [styles.cta_big_button_style]: ctaButtonStyle === 'big_button',
          [styles.white_cta]: cta_color === 'white',
          [styles.black_cta]: cta_color === 'black' || !cta_color,
        })}
        href={url}
        {...rest}
      >
        <CtaIcon iconValue={linkIcon} /> {children}
      </UniversalLink>
    </div>
  );
};

export default CTA;
